module.exports = __webpack_public_path__ + "static/media/logo-footer.cfd12841.png";